<template>
    <div>
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark">Dashboard</h1>
                    </div>
                    <span class="badge bg-info">
                        Current encoder statistics are cached data and will be refreshed
                        daily on user triggered basis, for real time statistics please use
                        the Transaction Report on the menu
                    </span>
                </div>
                <!-- /.row -->
            </div>
            <!-- /.container-fluid -->
        </div>

        <div class="row">
            <div class="col-lg-3 col-6">
                <!-- small box -->
                <div class="small-box bg-info">
                    <div class="inner">
                        <h3>{{ thismonth }}</h3>

                        <p>Documents for {{ currentMonth }}</p>
                    </div>
                    <div class="icon">
                        <i class="ion ion-bag"></i>
                    </div>
                </div>
            </div>
            <!-- ./col -->
            <div class="col-lg-3 col-6">
                <!-- small box -->
                <div class="small-box bg-success">
                    <div class="inner">
                        <h3>{{ totalencode }}</h3>

                        <p>Total Documents</p>
                    </div>
                    <div class="icon">
                        <i class="ion ion-stats-bars"></i>
                    </div>
                </div>
            </div>
            <!-- ./col -->
            <div class="col-lg-3 col-6">
                <!-- small box -->
                <div class="small-box bg-warning">
                    <div class="inner">
                        <h3>{{ linkobjects }}</h3>

                        <p>Linked Entities for {{ currentMonth }}</p>
                    </div>
                    <div class="icon">
                        <i class="ion ion-person-add"></i>
                    </div>
                </div>
            </div>
            <!-- ./col -->
            <div class="col-lg-3 col-6">
                <!-- small box -->
                <div class="small-box bg-danger">
                    <div class="inner">
                        <h3>{{ totallinkobjects }}</h3>

                        <p>Total Linked Entities</p>
                    </div>
                    <div class="icon">
                        <i class="ion ion-pie-graph"></i>
                    </div>
                </div>
            </div>
        </div>
        <!-- for the stat left 1st column -->
        <div class="row">
            <section class="col-lg-6">
                <div class="card card-outline card-primary" ref="prevEncode">
                    <div class="card-header">
                        <h3 class="card-title">Documents Statistics {{ previousYear }}</h3>
                    </div>
                    <div class="card-body">
                        <div class="tab-content p-0">
                            <bar-chart id="bar"
                                       :data="chartDataLastYearEncoded.rows"
                                       xkey="region"
                                       ykeys='["count"]'
                                       resize="true"
                                       labels='["Total"]'
                                       bar-colors='["#3548ea"]'
                                       xLabelAngle="35"
                                       barRatio="0.5"
                                       grid="true"
                                       grid-text-weight="bold"></bar-chart>
                        </div>
                    </div>
                </div>
                <div class="card card-outline card-success" ref="currentEncode">
                    <div class="card-header">
                        <h3 class="card-title">
                            Documents Statistics {{ currentYear }}
                            <span class="badge bg-info">Will be refreshed on a daily basis</span>
                        </h3>
                        <!-- <div class="card-tools pull-right">
                            <button type="button" class="btn btn-default btn-sm btn-tool" title="Refresh Encode Statistics" data-card-widget="" @click="loadEncodedCurrent()">Refresh</button>
                        </div> -->
                    </div>
                    <div class="card-body">
                        <div class="tab-content p-0">
                            <bar-chart id="bar1"
                                       :data="chartDataLatestEncoded.rows"
                                       xkey="region"
                                       ykeys='["count"]'
                                       resize="true"
                                       labels='["Total"]'
                                       bar-colors='["#3548ea"]'
                                       xLabelAngle="35"
                                       barRatio="0.5"
                                       grid="true"
                                       grid-text-weight="bold"></bar-chart>
                        </div>
                    </div>
                </div>
                <div class="card card-outline card-info" ref="currentProfile">
                    <div class="card-header">
                        <h3 class="card-title">
                            Profile Upload Statistics {{ currentYear }}
                            <span class="badge bg-info">Will be refreshed on a daily basis</span>
                        </h3>
                    </div>
                    <div class="card-body">
                        <div class="tab-content p-0">
                            <bar-chart id="bar5"
                                       :data="chartDataLatestProfile.rows"
                                       xkey="region"
                                       ykeys='["count"]'
                                       resize="true"
                                       labels='["Total"]'
                                       bar-colors='["#3548ea"]'
                                       xLabelAngle="35"
                                       barRatio="0.5"
                                       grid="true"
                                       grid-text-weight="bold"></bar-chart>
                        </div>
                    </div>
                </div>
            </section>
            <!-- for the stat right 2nd column -->
            <section class="col-lg-6">
                <div class="card card-outline card-primary" ref="prevLink">
                    <div class="card-header">
                        <h3 class="card-title">
                            Linked Entities Statistics {{ previousYear }}
                        </h3>
                        <div class="card-tools"></div>
                    </div>
                    <div class="card-body">
                        <div class="tab-content p-0">
                            <bar-chart id="bar2"
                                       :data="chartDataLastYearLinked.rows"
                                       xkey="region"
                                       ykeys='["count"]'
                                       resize="true"
                                       labels='["Total"]'
                                       bar-colors='["#3548ea"]'
                                       xLabelAngle="35"
                                       barRatio="0.5"
                                       grid="true"
                                       grid-text-weight="bold"></bar-chart>
                        </div>
                    </div>
                </div>
                <div class="card card-outline card-success" ref="currentLink">
                    <div class="card-header">
                        <h3 class="card-title">
                            Linked Entities Statistics {{ currentYear }}
                            <span class="badge bg-info">Will be refreshed on a daily basis</span>
                        </h3>
                        <!-- <div class="card-tools">
                            <button type="button" class="btn btn-default btn-sm btn-tool" title="Refresh Linked Statistics" data-card-widget="" @click="loadLinkedCurrent()">Refresh</button>
                        </div> -->
                    </div>
                    <div class="card-body">
                        <div class="tab-content p-0">
                            <bar-chart id="bar3"
                                       :data="chartDataLatestLinked.rows"
                                       xkey="region"
                                       ykeys='["count"]'
                                       resize="true"
                                       labels='["Total"]'
                                       bar-colors='["#3548ea"]'
                                       xLabelAngle="35"
                                       barRatio="0.5"
                                       grid="true"
                                       grid-text-weight="bold"></bar-chart>
                        </div>
                    </div>
                </div>
                <div class="card card-outline card-info" ref="prevProfile">
                    <div class="card-header">
                        <h3 class="card-title">
                            Profile Upload Statistics {{ previousYear }}
                        </h3>
                        <div class="card-tools"></div>
                    </div>
                    <div class="card-body">
                        <div class="tab-content p-0">
                            <bar-chart id="bar4"
                                       :data="chartDataLastYearProfile.rows"
                                       xkey="region"
                                       ykeys='["count"]'
                                       resize="true"
                                       labels='["Total"]'
                                       bar-colors='["#3548ea"]'
                                       xLabelAngle="35"
                                       barRatio="0.5"
                                       grid="true"
                                       grid-text-weight="bold"></bar-chart>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
    import { store } from "../store/store";
    import {
        authHeader,
        responseCheck,
        StatURL,
        getWithExpiry,
        setWithExpiry,
        getCountryandProvince
    } from "../helper";
    import Raphael from "raphael/raphael";
    global.Raphael = Raphael;
    import { BarChart } from "vue-morris";
    import instance from "../helper/http";
    export default {
        data() {
            return {
                monthNames: [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December",
                ],
                currentMonth: "",
                currentYear: new Date().getFullYear(),
                previousYear: new Date().getFullYear() - 1,
                chartDataLatestEncoded: {
                    columns: ["region", "count"],
                    rows: [],
                },
                chartDataLastYearEncoded: {
                    columns: ["region", "count"],
                    rows: [],
                },
                chartDataLatestLinked: {
                    columns: ["region", "count"],
                    rows: [],
                },
                chartDataLastYearLinked: {
                    columns: ["region", "count"],
                    rows: [],
                },
                chartDataCradEncode: {
                    columns: ["user", "count"],
                    rows: [],
                },
                chartDataCradLink: {
                    columns: ["user", "count"],
                    rows: [],
                },
                chartDataLatestProfile: {
                    columns: ["region", "count"],
                    rows: [],
                },
                chartDataLastYearProfile: {
                    columns: ["region", "count"],
                    rows: [],
                },
                thismonth: "",
                totalencode: "",
                linkobjects: "",
                totallinkobjects: "",
            };
        },
        components: {
            BarChart,
        },
        mounted() {
            getCountryandProvince();
            this.loadEncodedPrevious();
            this.loadEncodedCurrent();
            this.loadLinkedCurrent();
            this.loadLinkedPrevious();
            this.loadCurrentProfile();
            this.loadProfilePrevious();
            this.currMonth();
            let d = new Date();
            this.currentMonth = this.monthNames[d.getMonth()];
        },
        methods: {
            loadCurrentProfile() {
                let currentProfile = getWithExpiry("latest-profile");
                if (currentProfile) {
                    this.chartDataLatestProfile.rows = currentProfile;
                    return;
                }
                instance
                    .get(StatURL + "CurrentProfile", {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        this.chartDataLatestProfile.rows = response.data.data;
                        setWithExpiry("latest-profile", response.data.data, 14400000, false);
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            loadEncodedCurrent() {
                let currentEncode = getWithExpiry("latest-encoded");
                if (currentEncode) {
                    this.chartDataLatestEncoded.rows = currentEncode;
                    return;
                }
                instance
                    .get(StatURL + "Current", {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        this.chartDataLatestEncoded.rows = response.data.data;
                        setWithExpiry("latest-encoded", response.data.data, 14400000, false);
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            loadProfilePrevious() {
                let lastyearProfile = getWithExpiry("last-year-profile");
                if (lastyearProfile) {
                    this.chartDataLastYearProfile.rows = lastyearProfile;
                    return;
                }
                instance
                    .get(StatURL + "PreviousProfile", {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        this.chartDataLastYearProfile.rows = response.data.data;
                        setWithExpiry(
                            "last-year-profile",
                            response.data.data,
                            14400000,
                            false
                        );
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            loadEncodedPrevious() {
                let lastyearEncode = getWithExpiry("last-year-encoded");

                if (lastyearEncode) {
                    this.chartDataLastYearEncoded.rows = lastyearEncode;
                    return;
                }

                instance
                    .get(StatURL + "Previous", {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        this.chartDataLastYearEncoded.rows = response.data.data;
                        setWithExpiry(
                            "last-year-encoded",
                            response.data.data,
                            14400000,
                            false
                        );
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            loadLinkedCurrent() {
                let currentLink = getWithExpiry("latest-link");
                if (currentLink) {
                    this.chartDataLatestLinked.rows = currentLink;
                    return;
                }
                instance
                    .get(StatURL + "LinkedCurrent", {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        this.chartDataLatestLinked.rows = response.data.data;
                        setWithExpiry("latest-link", response.data.data, 14400000, false);
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            loadLinkedPrevious() {
                let prevLink = getWithExpiry("previous-link");
                if (prevLink) {
                    this.chartDataLastYearLinked.rows = prevLink;
                    return;
                }
                instance
                    .get(StatURL + "LinkedPrevious", {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        this.chartDataLastYearLinked.rows = response.data.data;
                        setWithExpiry("previous-link", response.data.data, 14400000, false);
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            currMonth() {
                if (store.getters.VIEWER) {
                    this.thismonth = 0;
                    this.Total();
                    return;
                }

                let currentmonth = getWithExpiry("auser-current-month");
                if (currentmonth) {
                    this.thismonth = currentmonth;
                    this.Total();
                    return;
                }

                instance
                    .get(StatURL + "usercurMonth", {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        this.thismonth = response.data.data;
                        setWithExpiry(
                            "auser-current-month",
                            response.data.data,
                            3600000,
                            true
                        );
                        this.Total();
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            Total() {
                if (store.getters.VIEWER) {
                    this.totalencode = 0;
                    this.TotalLinked();
                    return;
                }

                let usertotal = getWithExpiry("auser-total");
                if (usertotal) {
                    this.totalencode = usertotal;
                    this.TotalLinked();
                    return;
                }

                instance
                    .get(StatURL + "userTotal", {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        this.totalencode = response.data.data;
                        setWithExpiry("auser-total", response.data.data, 3600000, true);
                        this.TotalLinked();
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            TotalLinked() {
                if (store.getters.VIEWER) {
                    this.totallinkobjects = 0;
                    this.currLinked();
                    return;
                }
                let totallinked = getWithExpiry("auser-total-linked");
                if (totallinked) {
                    this.totallinkobjects = totallinked;
                    this.currLinked();
                    return;
                }
                instance
                    .get(StatURL + "totalLinked", {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        this.totallinkobjects = response.data.data;
                        setWithExpiry(
                            "auser-total-linked",
                            response.data.data,
                            3600000,
                            true
                        );
                        this.currLinked();
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            currLinked() {
                if (store.getters.VIEWER) {
                    this.totallinkobjects = 0;
                    return;
                }
                let currentlinked = getWithExpiry("auser-current-linked");
                if (currentlinked) {
                    this.linkobjects = currentlinked;
                    return;
                }
                instance
                    .get(StatURL + "currLinked", {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        this.linkobjects = response.data.data;
                        setWithExpiry(
                            "auser-current-linked",
                            response.data.data,
                            3600000,
                            true
                        );
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
        },
    };
</script>